import React from 'react';
import { Search, Close } from '@nike/nike-design-system-icons';
import { TextFieldStyled } from '@nike/nike-design-system-components';
import { useDispatch, useSelector } from 'react-redux';

import { TranslatedCopy } from '../intl/TranslatedCopy';
import { debounce } from '../util/debounce';
import { invitationsActions } from './invitations/actions';
import { invitationsSelectors } from './invitations/reducer';
import { useDispatchWithProgress } from '../hooks/useDispatchWithProgress';
import { usersActions } from './users/actions';
import { usersSelectors } from './users/reducer';

const UsersInvitationsSearchInput = () => {
  const dispatch = useDispatch();
  const searchUsers = useDispatchWithProgress(usersActions.searchSortUsers);

  const invitationsFilter = useSelector(invitationsSelectors.filter);
  const invitationsActiveReview = useSelector(invitationsSelectors.activeReview);
  const usersActiveReview = useSelector(usersSelectors.activeReview);
  const selectedAccountNumber = useSelector(state => state.user.get('userAccount')?.number);
  const usersSearch = useSelector(usersSelectors.search);
  const usersSort = useSelector(usersSelectors.sort);

  const handleClearSearch = () => {
    if (invitationsActiveReview) {
      dispatch({ type: invitationsActions.filterInvitations.name, payload: '' });
    } else {
      dispatch({ type: usersActions.resetUsers.name });
      dispatch({ type: usersActions.clearSearchInput.name });
      searchUsers({
        search: '',
        accountNumber: selectedAccountNumber,
        sort: usersSort,
        activeOnAccount: usersActiveReview
      });
    }
  };

  return (
    <TextFieldStyled
      id='usersInvitationsSearch'
      inputmode='search'
      label={new TranslatedCopy({ id: 'global.search' }).toString()}
      name='usersInvitationsSearch'
      onChange={debounce(event => {
        if (invitationsActiveReview) {
          dispatch({ type: invitationsActions.filterInvitations.name, payload: event.target.value });
        } else {
          dispatch({ type: usersActions.resetUsers.name });
          searchUsers({
            search: event.target.value,
            accountNumber: selectedAccountNumber,
            sort: usersSort,
            activeOnAccount: usersActiveReview
          });
        }
      }, 950)}
      style={{ minHeight: '68px', width: '350px' }} // height pre-.nds-input-container min-height
      value={usersSearch || invitationsFilter}
      PrefixIcon={<Search />}
      {...((usersSearch || invitationsFilter) && {
        TrailingIcon: <Close />
      })}
      onIconClick={handleClearSearch}
    />
  );
};

export default UsersInvitationsSearchInput;
